
import API from '@/api/api_sign'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

export default {
components: {
Swiper,
Tabbar,
Confirm,
TabbarItem,
Card,Group,Cell,CellFormPreview
},
data () {
return {
datas1:{},
show:false
}
},
created(){
this.dos();
},
methods: {
dos(){
API.psnInfo().then((res)=>{
if (res.code == '000000') {
this.datas1 = res.data;
}else{
this.$vux.toast.show({
type:'cancel;',
text:res.msg
});
}
})
},
out(){
this.show =true
},
onConfirm(){
window.localStorage.setItem('userInfo','');
this.$router.push("/login");
}
}
}



// WEBPACK FOOTER //
// ./src/pages/ren.vue